import type { AccessGrant } from '../../types';
import {
  AccessGrantDetailRow,
  AccessGrantDetailSection,
} from './access-grant-detail-row';
import { PolicyJsonViewer } from './policy-json-viewer';

import { useTranslation } from 'react-i18next';

function ActionList({ actions }: { actions: string[] | null }) {
  const { t } = useTranslation('accessGrants');
  if (actions === null) {
    return <span>{t('allActions')}</span>;
  }
  if (actions.length === 0) {
    return <span>{t('none')}</span>;
  }
  return (
    <ul className="flex flex-col gap-0.5">
      {actions.map((action) => (
        <li key={action}>{action}</li>
      ))}
    </ul>
  );
}

type AccessGrantPermissionsTabProperties = {
  grant: AccessGrant;
};

export function AccessGrantPermissionsTab({
  grant,
}: AccessGrantPermissionsTabProperties) {
  const { t } = useTranslation('accessGrants');
  const conditions =
    grant.conditions !== null && Object.keys(grant.conditions).length > 0
      ? grant.conditions
      : null;
  const hasNotActions =
    grant.allowedNotActions !== null && grant.allowedNotActions.length > 0;

  return (
    <div>
      <AccessGrantDetailSection title={t('allowed')}>
        <AccessGrantDetailRow
          label={t('actions')}
          value={<ActionList actions={grant.allowedActions} />}
        />
        {hasNotActions && (
          <AccessGrantDetailRow
            label="NotActions"
            value={<ActionList actions={grant.allowedNotActions} />}
          />
        )}
      </AccessGrantDetailSection>
      {conditions && (
        <AccessGrantDetailSection title={t('conditions')}>
          <div className="rounded-card border-container-border border">
            <PolicyJsonViewer document={conditions} />
          </div>
        </AccessGrantDetailSection>
      )}
    </div>
  );
}
